import { render, staticRenderFns } from "./BandejaInvisalingComponenteEntregar.vue?vue&type=template&id=14e1cbd8"
import script from "./BandejaInvisalingComponenteEntregar.vue?vue&type=script&lang=js"
export * from "./BandejaInvisalingComponenteEntregar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports